import { render } from "./FormManterSetor.vue?vue&type=template&id=73e75c46"
import script from "./FormManterSetor.vue?vue&type=script&lang=js"
export * from "./FormManterSetor.vue?vue&type=script&lang=js"

import "./FormManterSetor.vue?vue&type=style&index=0&id=73e75c46&lang=css"
/* custom blocks */
import block0 from "./FormManterSetor.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__